export const iconFontAwesomeHandsHandHolding = (
	<i className="fa-solid fa-hand-holding"></i>
);
